import { inject, Service } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Service()
export class AppNavigationService {
  private readonly router: Router = inject(Router);

  private _previousUrl: string | null = null;
  private _currentUrl: string | null = null;

  public routerEvents$ = this.router.events.pipe(
    tap((e) => {
      if (e instanceof NavigationEnd) {
        this._previousUrl = this._currentUrl;
        this._currentUrl = e.urlAfterRedirects;
      }
    })
  );

  getPreviousUrl(): string | null {
    return this._previousUrl;
  }
}
